import $ from 'jquery';
import _ from 'underscore';
import ajax from 'util/ajax';
import { $body, $window, jqOffOn } from 'util/global';


/** @module */
const pager = {};

// pagination
// --------------------------------------------------
var newsfeed_paginate_triggered_ts;
pager.paginate_triggered_ts = newsfeed_paginate_triggered_ts;
var newsfeed_paginate = function (classPart) {
    $body.on('click', `.newsfeed_${classPart}_paginate`, function(e) {
        e.preventDefault();
        e.stopPropagation();

        var $this = $(this),
            $next_container = $this.parents('.nf-next-container'),
            $child_stub_container = $next_container.siblings('.next_container_stub'),
            $child_stub = $child_stub_container.children().first(),
            page_key = $child_stub_container.data('page-key'),
            param_key,
            url;

        if(typeof $child_stub === 'undefined' || $child_stub.length == 0
                || $child_stub_container.hasClass('loaded')) {
            return;
        }

        param_key = $child_stub.attr('class').slice(4,-3);
        url = $this.data().next_url;

        $next_container.addClass('loading');

        var component_key = page_key + "_container";

        $child_stub_container.addClass('loaded');

        // grab a fresh copy of the ajax object
        var pagination_ajax = new ajax(component_key);

        // override the default error behavior
        pagination_ajax.error = function (response) {
            // if timeout error, reverse the loading state
            if(response.statusText === 'timeout') {
                $next_container.removeClass('loading');
                $child_stub_container.removeClass('loaded');

            // if some other error, hide everything about loading another page
            } else {
                $next_container.hide();
                $child_stub.hide();
            }
        };

        // set triggered timestamp
        newsfeed_paginate_triggered_ts = new Date().getTime();

        // reset pagination if inactive
        if(!autopagination_active) {
            newsfeed_autopagination(true);
        }

        var request_data = {
            page_key: page_key,
            param_key: param_key
        };

        var $wrapper = $this.parents('.nf-feed-wrapper'),
            feed_type = $wrapper.data('feed-type') || null,
            filter_content_type = $wrapper.data('filter_content_type') || '',
            popular = $wrapper.data('popular') || '',
            reviewed_state = $wrapper.data('reviewed_state') || '',
            user_to_display_id = $wrapper.data('user_to_display_id') || null;
        if($wrapper.length) {
            if(feed_type === 'normal') {
                request_data.show_all_content = true;
            }
            request_data.filter_content_type = filter_content_type;
            if(popular !== ''){
                request_data.popular = popular;
            }
            request_data.reviewed_state = reviewed_state;

            if(user_to_display_id) {
                request_data.user_to_display_id = user_to_display_id;
            }
        }

        // make the request
        pagination_ajax.get(url, request_data);
    });
};
pager.paginate = newsfeed_paginate;

pager.init = function() {
    $('.feed').not('.inited').each(function() {
        var $feed = $(this);
        var id = $feed.attr('id');
        var class_part = id.replace(/^newsfeed_/, '').replace(/_wrapper$/, '');
        newsfeed_paginate(class_part);
        $feed.addClass('inited');
    });
};


// infinite scroll
// --------------------------------------------------

pager.is_autopaginating = false;        // flag to avoid firing multiple requests

var autopagination_active = false,    // feed is currently autopaginating
    autopaginations_triggered,        // count number of pages loaded
    max_autopaginations = 10,         // max number of pages to load
    target_autopagination_point,      // scroll point at which new page should load
    $target_autopagination_container, // container related to target_..._point
    window_height;                    // current window height


// finds the next pagination container
// and sets the point at which the next page
// should auto load
var newsfeed_reset_autopagination_point = function () {
    $target_autopagination_container = $('.nf-next-container:not(.loaded):visible:last');
    pager.is_autopaginating = false;

    // if able to load a new page
    if($target_autopagination_container.length > 0 &&
        autopaginations_triggered < max_autopaginations) {
            // start loading 500px before the actual trigger point
            target_autopagination_point =
                $target_autopagination_container.offset().top - 500;

    // if unable to load a new page, stop listening for scroll
    } else {
        autopagination_active = false;
        $window.off('scroll.nfpage');
    }
};
pager.reset_autopagination_point = newsfeed_reset_autopagination_point;

var additional_pagination_counter;

// check how many items the last pagination request loaded
// and load another page if it's less than ideal
var newsfeed_needs_additional_pagination = function ($root) {
    var items_loaded = $root.find('.nf-feed-item:visible:not(.nf-next-empty)').length,
        items_needed = 4,
        additional_pagination_limit = 5;

    // if autopagination hasn't been turned off (too many page loads via scroll)
    if(autopagination_active) {

        // if there are items, but there are just a few items
        if(items_loaded > 0 && items_loaded < items_needed) {

            // if we haven't already loaded several pages, load another one
            if(additional_pagination_counter < additional_pagination_limit) {
                additional_pagination_counter ++;
                newsfeed_autopagination_paginate(false);
            }

        // otherwise, the page load was ok (end of feed or enough items)
        // reset the counter
        } else {
            additional_pagination_counter = 0;
        }
    }
};
pager.needs_additional_pagination = newsfeed_needs_additional_pagination;

// trigger pagination
// `should_count_for_limit=true` will increment the number of paginations
// that count toward the pagination limit
var newsfeed_autopagination_paginate = function (should_count_for_limit) {
    should_count_for_limit = should_count_for_limit === false ? false : true;

    if(!pager.is_autopaginating) {
        pager.is_autopaginating = true;
        $target_autopagination_container.find('a').click();
        if(should_count_for_limit) {
            autopaginations_triggered ++;
        }
    }
};


// initializes autopagination
var newsfeed_autopagination = function (reset) {
    reset = reset || false;
    window_height = $window.height();
    autopaginations_triggered = 0;
    additional_pagination_counter = 0;
    newsfeed_reset_autopagination_point();

    if($target_autopagination_container.length > 0) {
        autopagination_active = true;
        jqOffOn($window, 'scroll.nfpage', _.debounce(() => {
            // if it's time to load a new page, try to load a new page
            if (($window.scrollTop() + window_height) >= target_autopagination_point) {
                newsfeed_autopagination_paginate();
            }
        }, 100));
        if(!reset) {
            newsfeed_autopagination_paginate();
        }
    }
};
pager.autopagination = newsfeed_autopagination;

module.exports = pager;
